/* istanbul ignore file */
import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { ImageCroppingTaskStatusPoller } from './image-cropping-task-status-poller';
import { VideoTaskStatusPoller } from './video-task-status-poller';

export const withAssetTaskStatusPoller = (Component) => {
  const Wrapper = props => (
    <>
      <Component {...props} />
      <ImageCroppingTaskStatusPoller interval={10000} />
      <VideoTaskStatusPoller interval={10000} />
    </>
  );

  Wrapper.displayName = `withAssetTaskStatusPoller(${Component.displayName || Component.name})`;
  hoistNonReactStatics(Wrapper, Component);

  return Wrapper;
};
